import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import history from 'app/routes/history';
import Button from 'app/components/general/Button';
import { Label, Input, Form } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import SectionGroup from 'app/components/general/SectionGroup';
import Alert from 'app/components/general/Alert';
import { parseApiErrors } from 'app/utils/parsers';
import mappingTypes from 'app/utils/static/mappingTypes';
import peopleMappingValues from 'app/utils/static/peopleMappingValues';
import RightArrow from 'app/images/icons/right-arrow.svg';


interface IMapFieldsProps {
  match: any;
  requiredFields: any;
  defaultMapping: any;
  actions: any;
  availableFields: any;
  exampleRecord: any;
  staticData: any;
  groupImports: any;
  fileContent: string;
  competitions: any;
  organisations: any;
  connections: any;
}

interface IMapFieldsState {
  initialMappingSet: boolean;
  mappingType: any;
  mapping: any;
  changedMapping: boolean;
  changedMappingType: boolean;
}

export default class MapFields extends React.Component<
  IMapFieldsProps,
  IMapFieldsState
> {
  static defaultProps: IMapFieldsProps = {
    match: undefined,
    actions: undefined,
    groupImports: undefined,
    exampleRecord: undefined,
    staticData: undefined,
    fileContent: undefined,
    competitions: undefined,
    organisations: undefined,
    connections: undefined,
    requiredFields: [
      {
        name: 'Team Name',
        type: 'contact',
        key: 'teamName',
        required: true,
      },
      {
        name: 'Team Code',
        type: 'contact',
        key: 'uniqueCode',
        required: true,
      },
      {
        name: 'Section',
        type: 'contact',
        key: 'teamSection',
        required: true,
      },
      {
        name: 'Season',
        type: 'contact',
        key: 'season',
        required: true,
      },
      {
        name: 'Primary Contact Name',
        type: 'contact',
        key: 'teamManager.fullName',
        required: true,
      },
      {
        name: 'Primary Contact Mobile',
        type: 'contact',
        key: 'teamManager.mobile',
        required: true,
      },
      {
        name: 'Primary Contact Email',
        type: 'contact',
        key: 'teamManager.email',
        required: true,
      },
      {
        name: 'Primary Contact Unique Code',
        type: 'contact',
        key: 'teamManager.uniqueCode',
        required: true,
      },
      {
        name: 'Secondary Contact Name',
        type: 'contact',
        key: 'teamContact.fullName',
        required: false,
      },
      {
        name: 'Secondary Contact Mobile',
        type: 'contact',
        key: 'teamContact.mobile',
        required: false,
      },
      {
        name: 'Secondary Contact Email',
        type: 'contact',
        key: 'teamContact.email',
        required: false,
      },
      {
        name: 'Secondary Contact Unique Code',
        type: 'contact',
        key: 'teamContact.uniqueCode',
        required: false,
      },
    ],
    defaultMapping: {},
    availableFields: [],
  };

  state: IMapFieldsState = {
    initialMappingSet: false,
    mappingType: {
      id: 'teammo',
      name: 'Teammo',
    },
    changedMapping: false,
    changedMappingType: false,
    mapping: {},
  };

  componentDidMount(): void {
    if (_.isEmpty(this.props.fileContent)) {
      history.push('/import/teams');
    }
    this.setMapping();
  }

  componentDidUpdate(
    prevProps: IMapFieldsProps,
    prevState: IMapFieldsState,
  ): void {
    if (
      !this.state.changedMapping
      && (this.props !== prevProps
        || this.state.mapping !== prevState.mapping
        || this.state.mappingType !== prevState.mappingType)
    ) {
      this.setMapping();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (
      !prevState.changedMappingType
      && nextProps.organisations.currentOrganisation !== undefined
      && (prevState.mappingType === undefined
      || nextProps.organisations.currentOrganisation
        .competitionManagementSystem !== prevState.mappingType.id)
    ) {
      const mapping = _.find(
        mappingTypes,
        (mappingType) => mappingType.id
          === nextProps.organisations.currentOrganisation
            .competitionManagementSystem,
      );
      return {
        mappingType: mapping,
      };
    }
    return prevState;
  }

  setMapping = () => {
    const mappingType = _.isEmpty(this.state.mappingType)
      ? {
        id: 'teammo',
        name: 'Teammo',
      }
      : this.state.mappingType;
    const newMapping = peopleMappingValues[mappingType.id];
    const parsedMapping = {};

    _.map(newMapping, (mappingValue, key) => {
      if (_.includes(this.props.availableFields, mappingValue)) {
        parsedMapping[key] = mappingValue;
      }
    });
    this.setState((prevState) => ({
      ...prevState,
      initialMappingSet: true,
      mapping: parsedMapping,
      changedMapping: true,
    }));
  };

  checkIfAllMapped = () => {
    let valid = true;
    const requiredMapping = _.filter(this.props.requiredFields, {
      required: true,
    });

    _.map(requiredMapping, (mapping) => {
      if (_.isEmpty(this.state.mapping[mapping.key])) {
        valid = false;
      }
    });
    return valid;
  };

  handleMappingTypeChange = (e): void => {
    this.setState((prevState) => ({
      mappingType: e,
      changedMappingType: true,
      changedMapping: false,
    }));
  };

  handleMappingChange = (e, mappingField) => {
    this.setState((prevState) => {
      const newMapping = {
        ...prevState.mapping,
        [mappingField]: e.id,
      };
      return {
        mapping: newMapping,
        changedMapping: true,
      };
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const csvConnection = _.find(this.props.connections?.connectionsById, { code: 'csv' });

    if (this.checkIfAllMapped()) {
      const fileMapping = {};
      _.each(this.state.mapping, (value, key) => {
        fileMapping[key] = value;
      });

      const payload = {
        fileMapping,
        fileSource: 'body',
        fileType: 'csv',
        fileContent: this.props.fileContent,
        staticData: {
          'connection-id': csvConnection?.id,
          'competition-id': this.props.competitions.currentCompetitionId,
          'organisation-id': this.props.organisations.currentOrganisationId,
        },
      };
      this.props.actions.createGroupImport(payload, (connectionRunId) => {
        history.push(
          {
            pathname: `/import/teams/review/${connectionRunId}`,
            state: { modal: this.props.match.isModal },
          },
        );
      });
    }
    this.setState({
      changedMapping: false,
      changedMappingType: false,
    });
  };

  renderField = (field, selectOptions) => {
    let value;
    if (this.state.mapping[field.key] !== undefined) {
      value = {
        id: this.state.mapping[field.key],
        name: this.state.mapping[field.key],
      };
    }

    return (
      <div className="row" key={field.key}>
        <div className="col">
          <div className="mapping-container">
            <Input
              name={`${field.key}-mapping`}
              key={`${field.key}1`}
              placeholder=""
              className={classnames(
                'mapping-value',
                {
                  valid: !_.isEmpty(value),
                },
                {
                  invalid:
                    _.isEmpty(value)
                    && this.state.initialMappingSet
                    && field.required,
                },
              )}
              value={field.name}
              readOnly="readOnly"
              onChange={() => {}}
            />
            <Isvg className="mapping-arrow" src={RightArrow} />
            <InputGroupBlock
              name={field.key}
              className="w-100 height-40"
              placeholder=""
              type="select"
              options={selectOptions}
              key={`${field.key}2`}
              value={value}
              onChange={(e) => this.handleMappingChange(e, field.key)}
            />
          </div>
        </div>
      </div>
    );
  };

  renderMappingOptions = () => {
    const selectOptions = _.map(
      this.props.availableFields,
      (availableField) => ({
        id: availableField,
        name: availableField,
      }),
    );
    const contactFields = _.filter(this.props.requiredFields, {
      type: 'contact',
    });

    return [
      _.map(contactFields, (field) => this.renderField(field, selectOptions)),
    ];
  };

  renderMappingSelect = (): React.ReactNode => (
    <InputGroupBlock
      type="select"
      labelText="Mapping Type"
      name="mappingType"
      isMulti={false}
      placeholder="Mapping Type"
      aria-label="Mapping Type"
      autoComplete="off"
      tabIndex="2"
      value={this.state.mappingType}
      options={mappingTypes}
      onChange={this.handleMappingTypeChange}
    />
  );

  renderBackendErrors(): React.ReactNode {
    if (
      !_.isEmpty(this.props.groupImports?.backendErrors)
    ) {
      return (
        <Alert color="error">
          {parseApiErrors(this.props.groupImports?.backendErrors)}
        </Alert>
      );
    }
    return null;
  }

  render(): React.ReactNode {
    const csvConnection = _.find(this.props.connections?.connectionsById, { code: 'csv' });
    return (
      <div>
        <SectionGroup title="Mapping Type" notification="">
          <div className="row">
            <div className="col">{this.renderMappingSelect()}</div>
          </div>
        </SectionGroup>

        <SectionGroup title="Map Fields" notification="">
          <Form onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="col">
                <div className="form-description">
                  Map the fields from your file to the required data.
                </div>
              </div>
            </div>
            {this.renderBackendErrors()}
            <div className="section with-margin-top-10">
              <div className="row">
                <div className="col">
                  <div className="row">
                    <div className="col mapping-container mapping-header">
                      <Label className="mapping-heading">Team Data</Label>
                      <div className="mapping-spacer" />
                      <Label className="mapping-heading">
                        Column from CSV file
                      </Label>
                    </div>
                  </div>
                  {this.renderMappingOptions()}
                </div>
              </div>
              <div className="row">
                <div className="col btn-flex-group less-padding">
                  <div className="btn-flex-container">
                    <Button
                      className={classnames('btn-standard btn-1', {
                        'd-none': !this.checkIfAllMapped(),
                      })}
                      isLoading={this.props.groupImports.isSaving}
                      hasSaved={this.props.groupImports.hasSaved}
                      hasFailed={this.props.groupImports.hasFailed}
                      type="submit"
                    >
                      Import
                    </Button>
                    <Button
                      onClick={() => history.goBack()}
                      className="btn-standard btn-2 margin-right-auto"
                    >
                      Back
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </SectionGroup>
      </div>
    );
  }
}
